import { useState } from 'react';
import DocToHtmlFormPreview from '../components/DocToHtmlFormPreview';
import type { Template } from '../api/endpoints/fetchTemplates';

export function DocToHtmlPreview() {
  const [isInfoPanelOpen, setIsInfoPanelOpen] = useState(false);

  // Mock template for demo purposes
  const mockTemplate: Template = {
    id: 'doc-to-html-demo',
    fileTitle: 'Document to HTML Form',
    fileName: 'doc-schema',
    fileId: 'doc-schema-001',
    htmlFileId: { id: 'html-001', name: 'html' },
    userEmail: 'demo@example.com',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPublished: false,
    pdfType: 'CUSTOM_FORM',
    isAcroFile: false,
    memberId: undefined,
  };

  return (
    <DocToHtmlFormPreview
      template={mockTemplate}
      onClose={() => {}}
      onSaved={() => {}}
      onInfo={() => setIsInfoPanelOpen(!isInfoPanelOpen)}
      isInfoPanelOpen={isInfoPanelOpen}
    />
  );
}

export default DocToHtmlPreview;
